import { render } from "./AppListItem.vue?vue&type=template&id=2a50114e&ts=true"
import script from "./AppListItem.vue?vue&type=script&lang=ts"
export * from "./AppListItem.vue?vue&type=script&lang=ts"

import "./AppListItem.vue?vue&type=style&index=0&id=2a50114e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__